import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/ai_content/content_entities/index.vue') }
}

export class ArchivedController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/ai_content/content_entities/archived.vue') }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/ai_content/content_entities/show.vue') }

  static values = { // описание ожидаемых контроллером параметров для стимулуса
    contentEntityId: String,
    title: String,
    contentScore: Number,
    totalTokens: Number,
    model: String,
    locationId: String,
    locationName: String,
    locationAddress: String,
    contentTypeId: String,
    contentTypeName: String,
    isOwner: Boolean,
    orderId: String,
    orderNumber: String,
    status: String
  }

  connect() {
    super.connect({ // заколить метод бейз класса с нужными пропсами
      contentEntityId: this.contentEntityIdValue,
      title: this.titleValue,
      contentScore: this.contentScoreValue,
      totalTokens: this.totalTokensValue,
      model: this.modelValue,
      locationId: this.locationIdValue,
      locationName: this.locationNameValue,
      locationAddress: this.locationAddressValue,
      contentTypeId: this.contentTypeIdValue,
      contentTypeName: this.contentTypeNameValue,
      isOwner: this.isOwnerValue,
      orderId: this.orderIdValue,
      orderNumber: this.orderNumberValue,
      status: this.statusValue
    })
  }
}
